module.exports = __webpack_public_path__ + "img/78.8.TSS.f1b40150.png";